/**
 * Positions Component
 * Displays open positions with real-time P&L
 */

import { usePositions } from '../api/client';

export function Positions() {
  const { data, isLoading, error } = usePositions();

  if (isLoading) {
    return (
      <div className="card">
        <div className="loading">Loading positions...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="card">
        <div className="error">Error loading positions: {error.message}</div>
      </div>
    );
  }

  const positions = data?.positions || [];

  return (
    <div className="card">
      <div className="card-header">
        <h2 className="card-title">Open Positions</h2>
        <span className="card-badge badge-success">{positions.length} Active</span>
      </div>

      {positions.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state-icon">📊</div>
          <p>No open positions</p>
        </div>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>Symbol</th>
              <th>Sector</th>
              <th>Entry Price</th>
              <th>Current Price</th>
              <th>Quantity</th>
              <th>P&L ($)</th>
              <th>P&L (%)</th>
              <th>Trailing Stop</th>
            </tr>
          </thead>
          <tbody>
            {positions.map((position) => (
              <tr key={position.id}>
                <td>
                  <strong>{position.symbol}</strong>
                </td>
                <td>{position.sector || 'N/A'}</td>
                <td>${position.entryPrice.toFixed(2)}</td>
                <td>${position.currentPrice.toFixed(2)}</td>
                <td>{position.quantity}</td>
                <td className={position.pnl >= 0 ? 'positive' : 'negative'}>
                  {position.pnl >= 0 ? '+' : ''}${position.pnl.toFixed(2)}
                </td>
                <td className={position.pnlPct >= 0 ? 'positive' : 'negative'}>
                  {position.pnlPct >= 0 ? '+' : ''}{position.pnlPct.toFixed(2)}%
                </td>
                <td>
                  {position.trailingStopActivated ? (
                    <span style={{ color: 'var(--accent-yellow)' }}>
                      {position.trailingStopPct?.toFixed(2)}%
                    </span>
                  ) : (
                    <span style={{ color: 'var(--text-secondary)' }}>—</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {positions.length > 0 && (
        <div style={{ marginTop: '1rem', fontSize: '0.875rem', color: 'var(--text-secondary)' }}>
          Total Value: $
          {positions
            .reduce((sum, p) => sum + p.currentPrice * p.quantity, 0)
            .toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
        </div>
      )}
    </div>
  );
}
